// Language Guide (proto 3) | Protocol Buffers Documentation https://protobuf.dev/programming-guides/proto3/

// @generated by protoc-gen-connect-es v0.11.0 with parameter "target=js+dts"
// @generated from file v1/main.proto (package v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddGroupWorksRequest, AddGroupWorksResponse, AddWorksRequest, AddWorksResponse, DeleteAllUserRequest, DeleteAllUserResponse, DeleteGroupWorkRequest, DeleteGroupWorkResponse, DeleteUserRequest, DeleteUserResponse, DeleteWorkRequest, DeleteWorkResponse, GetAdminsRequest, GetAdminsResponse, GetAllUserExRequest, GetAllUserExResponse, GetCoursewareByProjectRequest, GetCoursewareByProjectResponse, GetCoursewareFileListRequest, GetCoursewareFileListResponse, GetCoursewareFileTreeRequest, GetCoursewareFileTreeResponse, GetCoursewaresRequest, GetCoursewaresResponse, GetCoursewareTreeRequest, GetCoursewareTreeResponse, GetLastIdRequest, GetLastIdResponse, GetLogsRequest, GetLogsResponse, GetRegistrationLogsRequest, GetRegistrationLogsResponse, GetSchoolroomLastNumberRequest, GetSchoolroomLastNumberResponse, GetSchoolroomRequest, GetSchoolroomResponse, GetSchoolroomsRequest, GetSchoolroomsResponse, GetStudentsExResponse, GetStudentsRequest, GetStudentsResponse, GetTeachersRequest, GetTeachersResponse, GetUserRequest, GetUserResponse, GetVendorsRequest, GetVendorsResponse, GetWorksRequest, GetWorksResponse, HealthRequest, HealthResponse, HomeRequest, HomeResponse, IssueCodeRequest, IssueCodeResponse, LoginRequest, LoginResponse, LogoutRequest, LogoutResponse, RegisterCoursewaresRequest, RegisterCoursewaresResponse, SaveSchoolroomRequest, SaveSchoolroomResponse, SaveStudentsExRequest, SaveStudentsExResponse, SaveUserRequest, SaveUserResponse, SaveWorkRequest, SaveWorkResponse, UpdateUserImageRequest, UpdateUserImageResponse } from "./main_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service v1.MainService
 */
export const MainService = {
  typeName: "v1.MainService",
  methods: {
    /**
     * @generated from rpc v1.MainService.Health
     */
    health: {
      name: "Health",
      I: HealthRequest,
      O: HealthResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.Home
     */
    home: {
      name: "Home",
      I: HomeRequest,
      O: HomeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.Login
     */
    login: {
      name: "Login",
      I: LoginRequest,
      O: LoginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.Logout
     */
    logout: {
      name: "Logout",
      I: LogoutRequest,
      O: LogoutResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetAdmins
     */
    getAdmins: {
      name: "GetAdmins",
      I: GetAdminsRequest,
      O: GetAdminsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetVendors
     */
    getVendors: {
      name: "GetVendors",
      I: GetVendorsRequest,
      O: GetVendorsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetTeachers
     */
    getTeachers: {
      name: "GetTeachers",
      I: GetTeachersRequest,
      O: GetTeachersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetStudents
     */
    getStudents: {
      name: "GetStudents",
      I: GetStudentsRequest,
      O: GetStudentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetStudentsEx
     */
    getStudentsEx: {
      name: "GetStudentsEx",
      I: GetStudentsRequest,
      O: GetStudentsExResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.SaveStudentsEx
     */
    saveStudentsEx: {
      name: "SaveStudentsEx",
      I: SaveStudentsExRequest,
      O: SaveStudentsExResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetUser
     */
    getUser: {
      name: "GetUser",
      I: GetUserRequest,
      O: GetUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetAllUserEx
     */
    getAllUserEx: {
      name: "GetAllUserEx",
      I: GetAllUserExRequest,
      O: GetAllUserExResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.SaveUser
     */
    saveUser: {
      name: "SaveUser",
      I: SaveUserRequest,
      O: SaveUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.UpdateUserImage
     */
    updateUserImage: {
      name: "UpdateUserImage",
      I: UpdateUserImageRequest,
      O: UpdateUserImageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.DeleteUser
     */
    deleteUser: {
      name: "DeleteUser",
      I: DeleteUserRequest,
      O: DeleteUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.DeleteAllUser
     */
    deleteAllUser: {
      name: "DeleteAllUser",
      I: DeleteAllUserRequest,
      O: DeleteAllUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.IssueCode
     */
    issueCode: {
      name: "IssueCode",
      I: IssueCodeRequest,
      O: IssueCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetLastId
     */
    getLastId: {
      name: "GetLastId",
      I: GetLastIdRequest,
      O: GetLastIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Schoolroom
     *
     * @generated from rpc v1.MainService.GetSchoolroomLastNumber
     */
    getSchoolroomLastNumber: {
      name: "GetSchoolroomLastNumber",
      I: GetSchoolroomLastNumberRequest,
      O: GetSchoolroomLastNumberResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetSchoolrooms
     */
    getSchoolrooms: {
      name: "GetSchoolrooms",
      I: GetSchoolroomsRequest,
      O: GetSchoolroomsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetSchoolroom
     */
    getSchoolroom: {
      name: "GetSchoolroom",
      I: GetSchoolroomRequest,
      O: GetSchoolroomResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.SaveSchoolroom
     */
    saveSchoolroom: {
      name: "SaveSchoolroom",
      I: SaveSchoolroomRequest,
      O: SaveSchoolroomResponse,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Courseware
     *
     * @generated from rpc v1.MainService.GetCoursewareFileTree
     */
    getCoursewareFileTree: {
      name: "GetCoursewareFileTree",
      I: GetCoursewareFileTreeRequest,
      O: GetCoursewareFileTreeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetCoursewareTree
     */
    getCoursewareTree: {
      name: "GetCoursewareTree",
      I: GetCoursewareTreeRequest,
      O: GetCoursewareTreeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.RegisterCoursewares
     */
    registerCoursewares: {
      name: "RegisterCoursewares",
      I: RegisterCoursewaresRequest,
      O: RegisterCoursewaresResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ”～Tree” の方が主となったので、要らないのではないか
     *
     * @generated from rpc v1.MainService.GetCoursewareFileList
     */
    getCoursewareFileList: {
      name: "GetCoursewareFileList",
      I: GetCoursewareFileListRequest,
      O: GetCoursewareFileListResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetCoursewares
     */
    getCoursewares: {
      name: "GetCoursewares",
      I: GetCoursewaresRequest,
      O: GetCoursewaresResponse,
      kind: MethodKind.Unary,
    },
    /**
     * by 非生徒
     *
     * @generated from rpc v1.MainService.GetWorks
     */
    getWorks: {
      name: "GetWorks",
      I: GetWorksRequest,
      O: GetWorksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.AddWorks
     */
    addWorks: {
      name: "AddWorks",
      I: AddWorksRequest,
      O: AddWorksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.AddGroupWorks
     */
    addGroupWorks: {
      name: "AddGroupWorks",
      I: AddGroupWorksRequest,
      O: AddGroupWorksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.DeleteWork
     */
    deleteWork: {
      name: "DeleteWork",
      I: DeleteWorkRequest,
      O: DeleteWorkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.DeleteGroupWork
     */
    deleteGroupWork: {
      name: "DeleteGroupWork",
      I: DeleteGroupWorkRequest,
      O: DeleteGroupWorkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * by 非生徒・生徒共に
     *
     * @generated from rpc v1.MainService.GetCoursewareByProject
     */
    getCoursewareByProject: {
      name: "GetCoursewareByProject",
      I: GetCoursewareByProjectRequest,
      O: GetCoursewareByProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.SaveWork
     */
    saveWork: {
      name: "SaveWork",
      I: SaveWorkRequest,
      O: SaveWorkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetLogs
     */
    getLogs: {
      name: "GetLogs",
      I: GetLogsRequest,
      O: GetLogsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc v1.MainService.GetRegistrationLogs
     */
    getRegistrationLogs: {
      name: "GetRegistrationLogs",
      I: GetRegistrationLogsRequest,
      O: GetRegistrationLogsResponse,
      kind: MethodKind.Unary,
    },
  }
};

